import React from 'react';
import './Footer.css';

const Footer = () => {
  const footerSections = [
    {
      title: "Services",
      links: [
        { text: "Web Development", href: "#" },
        { text: "Mobile Development", href: "#" },
        { text: "Cloud & DevOps", href: "#" },
        { text: "AI & Machine Learning", href: "#" }
      ]
    },
    {
      title: "Industries",
      links: [
        { text: "Media & Advertising", href: "#" },
        { text: "Education & EdTech", href: "#" },
        { text: "Travel & Hospitality", href: "#" },
        { text: "Retail", href: "#" },
        { text: "Supply Chain & Logistics", href: "#" },
        { text: "Healthcare", href: "#" },
        { text: "FinTech", href: "#" },
        { text: "Agriculture & Agritech", href: "#" }
      ]
    },
    {
      title: "Company",
      links: [
        { text: "About Us", href: "#" },
        { text: "Careers", href: "#" },
        { text: "Contact Us", href: "#" }
      ]
    },
    {
      title: "Resources",
      links: [
        { text: "Success Stories", href: "#" },
        { text: "White Papers", href: "#" },
        { text: "Blogs", href: "#" }
      ]
    }
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img src="/src/images/Ororo-logo.png" alt="Ororo Solutions logo" className="logo-img" style={{ width: '200px', height: '80px' }} />
            </div>
            <p>A leading African software development company, empowering businesses with innovative digital solutions.</p>
            <div className="social-links">
              <a href="#" aria-label="LinkedIn"><i className="fab fa-linkedin"></i></a>
              <a href="#" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
              <a href="#" aria-label="Facebook"><i className="fab fa-facebook"></i></a>
              
            </div>
          </div>

          {footerSections.map((section, index) => (
            <div key={index} className="footer-section">
              <h4>{section.title}</h4>
              <ul>
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <a href={link.href}>{link.text}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2025 Ororo Software Solutions. All rights reserved.</p>
            <div className="footer-links">
              <a href="#">Privacy Policy</a>
              <a href="#">Terms of Service</a>
              <a href="#">Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 